var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Content',{attrs:{"title":"Register"}},[_c('div',{staticClass:"flex justify-center items-center"},[(_vm.loaded)?_c('Form',{attrs:{"fields":[
          {name: 'firstName', type: 'text', size: 3, maxlength: 30},
          {name: 'lastName', type: 'text', size: 3},
          {name: 'email', type: 'email', confirm: true, disabled: !!_vm.providedEmail, default: _vm.providedEmail},
          {name: 'password', type: 'password', confirm: true} ],"width":"400px","submitText":"Register","onSubmit":this.onSubmit,"submitRight":true}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }